import { createReducer } from '@reduxjs/toolkit'

import { LoaderActions } from './actions'
import type { LoadersState } from './types'

export const loadersReducer = createReducer<LoadersState>([], (builder) =>
  builder
    .addCase(LoaderActions.set, (state, { payload }) => [...state, payload])
    .addCase(LoaderActions.unset, (state, { payload }) =>
      state.filter((t) => t !== payload)
    )
)
